<template>
    <div>
        <div class="rel" style="width: 100%;height: 208px;">
            <banner akey="wx_banner1" height="208px" width="100%" class="abs" style="top:0;left:0;right:0;bottom:0;width: 100%;height: 208px;"></banner>
            <div class="bg-light-op80 flex flex-row hide flex-ai padding-5 border-radius abs" style="width: 80%;bottom:20px;left:10%;height: 30px;">
                <input placeholder="请输入招标项目名称" class="bg-transparent border-0 f14 flex1" style="height: 20px;" @click="$router.push({path:'/search'})"/>
                <van-icon name="search" color="#1f56a4"/>
            </div>
        </div>
        <div class="margin-top-20 text-center dark-3">— 订阅 —</div>
        <div class="margin-top margin-left-20 margin-right-20">
            <van-row gutter="5">
                <van-col span="6" class="margin-bottom-5" v-for="(item,index) in hyList" @click="$router.push({path:$route.query.rss2 ? '/rss2' : '/rss',query:{...$route.query}})">
                    <span class="tag-item block" :class="chooseHyId.indexOf(item.id) >= 0 ? 'on' : ''" @click="">{{item.name}}</span>
                </van-col>
            </van-row>
        </div>
        <div class="margin-top-20">
            <banner akey="wx_banner2" height="77px" width="100%"></banner>
<!--            <img src="/images/banner2.jpg" style="width: 100%"/>-->
        </div>
        <div class="margin-top-20 text-center dark-3">— 招标公告 —</div>
        <div class="bg-gray-4 margin-top padding-top-bottom padding-left-right-20">
            <div class="flex flex-row flex-ai padding-top-bottom" v-for="(item,index) in noticeList">
                <span class="inline-block bg-blue li-dot"></span>
                <a :href="'/bids/detail/'+item.id+($utils.querystring($route.query) ? '?'+$utils.querystring($route.query) : '')" class="f14 flex1 text-line-1 dark-2">{{item.title}}</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    data(){
        return{
            hyList:[],
            chooseHyId:'',
            noticeList:[],
            chooseAreaList:[]
        }
    },
    created() {
        this.$emit('bgColor','#fff');
        // this.chooseHyId = this.$user.getHy2() ? this.$user.getHy2() : '';
        // this.chooseAreaList = this.$user.getArea2() ? this.$user.getArea2() : [];

        if(this.$user.getToken()) {
            this.getMyInterest();
        }else{
            this.getNotice();
        }
    },
    // created() {
    //     this.chooseAreaList = this.$user.getArea() ? this.$user.getArea() : [];
    //     this.chooseHyList = this.$user.getHy() ? this.$user.getHy() : [];
    // },
    mounted() {
        this.getHy();
        // this.getNotice();
    },
    methods: {
        getHy() {
            let _this = this;
            this.$http.post({
                url: 'Type/listPage',
                data: {akey: 'industry',state:1,page:1,pageSize:12,orderBy:'sort',sortBy:'asc'},
                success(res) {
                    _this.hyList = res.list;
                }
            })
        },
        getNotice() {
            let _this = this;
            let _where = {};

            if(this.chooseHyId){
                _where['type_industry_id'] = [this.chooseHyId,'in'];
            }

            if(this.chooseAreaList && this.chooseAreaList.length > 0){
                _where['province_code'] = [this.chooseAreaList,'in'];
            }

            this.$http.post({
                url: 'Bids/listPage',
                data: {type: 'notice',state:1,page:1,pageSize:5,..._where},
                success(res) {
                    if(res.list.length <= 0){
                        _this.getList();
                    }else {
                        _this.noticeList = res.list;
                    }
                }
            })
        },
        getList() {
            let _this = this;
            this.$http.post({
                url: 'Bids/listPage',
                data: {type: 'notice',state:1,page:1,pageSize:5},
                success(res) {
                    _this.noticeList = res.list;
                }
            })
        },
        getMyInterest(){
            let _this = this;
            this.$http.post({
                url:'AuthUser/getInterest',
                data:null,
                success(res){
                    _this.chooseHyId = res.hangye_ids && res.hangye_ids.length > 0 ? res.hangye_ids : '';
                    _this.chooseAreaList = res.province_codes;
                    // _this.hyList = res;
                    _this.getNotice();
                }
            })
        }
    }
}
</script>
